module.exports = {
      id: "lombardia-logo-usage",
      viewBox: "0 0 512 153",
      url: __webpack_public_path__ + "images/sprites/brand.svg#lombardia-logo-usage",
      toString: function () {
        return this.url;
      }
    }